export function Ratio2x3Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="4.375" y="1.25" width="11.25" height="17.5" rx="2" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio2x3Icon.displayName = 'Ratio2x3Icon';
